export const firebaseConfig = {
  "projectId": "studio-2771643006-c0a94",
  "appId": "1:122398892193:web:a1c09a916f39ed182e10e0",
  "storageBucket": "studio-2771643006-c0a94.firebasestorage.app",
  "apiKey": "AIzaSyDlWEKzjtkrvVLaFai2MWfLxyQAF2JPT4Y",
  "authDomain": "studio-2771643006-c0a94.firebaseapp.com",
  "measurementId": "",
  "messagingSenderId": "122398892193"
};
